import { useNavigate } from "react-router";
import { DataGrid, type DataGridColumn } from "@/components/data-grid";
import { Badge } from "@/components/ui/badge";
import { modeLabel, useDatasheets, type DatasheetRow } from "@/lib/datasheets";

/// Screen D-2. A tab on the existing company profile rather than its own route — this is where
/// users actually look for a customer's standing sheets. The company column is dropped because
/// the page header already names the company.
export function CompanyDatasheetsTab({ companyId }: { companyId: number }) {
  const navigate = useNavigate();
  const { data, isLoading } = useDatasheets({ companyId, page: 1, pageSize: 100 });
  const rows = data?.items ?? [];

  const cols: DataGridColumn<DatasheetRow>[] = [
    { id: "id", header: "Datasheet", accessor: (r) => `#${r.datasheetId}` },
    { id: "type", header: "Type", accessor: (r) => r.datasheetTypeDescription ?? r.datasheetTypeCode },
    { id: "contact", header: "Primary contact", accessor: (r) => r.primaryContactName ?? "—" },
    { id: "mode", header: "Mode", accessor: (r) => <Badge variant="secondary">{modeLabel(r.mode)}</Badge> },
    { id: "remaining", header: "Remaining", accessor: (r) => String(r.totalRemaining) },
    {
      id: "warn",
      header: "",
      accessor: (r) =>
        r.hasWarnings ? (
          <span aria-label="Needs attention" title="Balances need attention" className="text-amber-600">●</span>
        ) : null,
    },
  ];

  return (
    <DataGrid
      columns={cols}
      rows={rows}
      rowKey={(r) => r.datasheetId}
      totalRows={rows.length}
      pageIndex={0}
      pageSize={100}
      loading={isLoading}
      emptyHeadline="No datasheets for this company yet."
      onPageChange={() => {}}
      onRowClick={(r) => void navigate(`/datasheets/${r.datasheetId}`)}
    />
  );
}
